import { type ChangeEvent, type MouseEvent, useState } from "react";

import {
  Box,
  Checkbox,
  ClickAwayListener,
  FormControlLabel,
  FormGroup,
  type SxProps,
  type Theme,
  Typography,
} from "@mui/material";

import { cloudZeroTxt } from "../../assets/texts/CloudZero/cloudzero";
import HtmlTooltip from "../Tooltip/HtmlTooltip";
import CloudZeroTooltip from "./CloudZeroTooltip";

type Props = {
  checked: boolean;
  disabled: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  sx?: SxProps<Theme>;
};

const CloudZeroCheckbox = ({ checked, disabled, onChange, sx }: Props) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleTooltipOpen = (e: MouseEvent) => {
    e.preventDefault();
    setIsTooltipOpen(true);
  };

  const handleTooltipClose = () => {
    setIsTooltipOpen(false);
  };

  return (
    <FormGroup sx={sx}>
      <FormControlLabel
        disabled={disabled}
        control={<Checkbox size="small" checked={checked} onChange={onChange} sx={{ py: 0, pr: 0.25 }} />}
        label={
          <Typography variant="caption">
            {cloudZeroTxt.INCLUDE}
            <ClickAwayListener onClickAway={handleTooltipClose}>
              <span>
                <HtmlTooltip
                  PopperProps={{
                    disablePortal: true,
                  }}
                  onClose={handleTooltipClose}
                  open={isTooltipOpen}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  title={<CloudZeroTooltip />}
                >
                  <Box
                    sx={{ borderBottom: "1px dotted ", borderColor: "text.primary" }}
                    component="span"
                    onClick={handleTooltipOpen}
                  >
                    {cloudZeroTxt.CLOUDZERO_DATA}
                  </Box>
                </HtmlTooltip>
              </span>
            </ClickAwayListener>
          </Typography>
        }
      />
    </FormGroup>
  );
};

export default CloudZeroCheckbox;
